(function ($) {
  'use strict';

  Drupal.behaviors.frontendCommerceCartBubble = {
    attach: function (context) {
      $('.commerce-cart-bubble', context).each(function () {
        $(this).text(getCookieValue('commerce-cart-count'));
      });
    }
  };

  function getCookieValue(a) {
    var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
  }

})(jQuery);
